var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _mask, _style, _g, _g2, _g3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVisual(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "55vh",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 50.99 52.87"
  }, props), /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "visual_svg__gradient",
    x1: 174.13,
    y1: 2225.06,
    x2: 197.79,
    y2: 2292.73,
    gradientTransform: "matrix(.1 0 0 .1 17.28 -200.82)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bacdff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#b7cbff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9cb7ff"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "visual_svg__gradient_2",
    x1: -123.88,
    y1: 2147.56,
    x2: 32.96,
    y2: 2147.56,
    gradientTransform: "matrix(.1 0 0 .1 17.28 -200.82)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cb7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#c1d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#c4d5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a9c1ff"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "visual_svg__gradient_3",
    x1: -69.74,
    y1: 1958.91,
    x2: 52.26,
    y2: 2067.31,
    gradientTransform: "matrix(.1 0 0 .1 17.28 -200.82)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b4c9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#c4d5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#c4d5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9cb7ff"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "visual_svg__gradient_4",
    x1: 135.46,
    y1: 2329.44,
    x2: 213.81,
    y2: 2380.7,
    gradientTransform: "matrix(.1 0 0 .1 17.28 -200.82)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c1d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#c1d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#adc4ff"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "visual_svg__gradient_5",
    x1: 106.49,
    y1: 2160.68,
    x2: 69.02,
    y2: 2305.06,
    gradientTransform: "matrix(.1 0 0 .1 17.28 -200.82)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cb7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#9cb7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9cb7ff"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "visual_svg__gradient_6",
    x1: 157.84,
    y1: 2074.27,
    x2: 298.93,
    y2: 2399.46,
    gradientTransform: "matrix(.1 0 0 .1 17.28 -200.82)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b7cbff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#c4d5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#c4d5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9cb7ff"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "visual_svg__gradient_7",
    x1: -23.28,
    y1: 2104.97,
    x2: 0.38,
    y2: 2172.64,
    xlinkHref: "#visual_svg__gradient"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "visual_svg__mask-01"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.62 8.77C11.6.19 5.48 4.4 3.88 10.51 1.75 18.65 6.43 32.33 16 34.22a6.63 6.63 0 007.51-3.81c1.61-3.58 1.58-10.41 4.64-12.54 2.82-2 5.64-2.57 8.74-1 15 7.68 10.59 42.81-7.64 23.67",
    style: {
      animationName: "path-ani",
      animationDuration: "8s",
      animationTimingFunction: "cubic-bezier(.16,.9,.72,1)"
    },
    stroke: "var(--bs-white)",
    strokeWidth: 11,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: 150,
    strokeDashoffset: 300
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "visual_svg__mask-02"
  }, /*#__PURE__*/React.createElement("path", {
    className: "visual_svg__mask-line",
    d: "M40.41 29.68l-9.3 3.41"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "visual_svg__mask-03"
  }, /*#__PURE__*/React.createElement("path", {
    className: "visual_svg__mask-line",
    style: {
      animationDuration: "8.8s"
    },
    d: "M19.62 17.06l-9.3 3.41"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", null, "@keyframes path-ani{0%{opacity:0;stroke-dashoffset:150}75%{opacity:1;stroke-dashoffset:150}to{stroke-dashoffset:300}}@keyframes circle-ani{0%{opacity:0;stroke-dashoffset:16}90%{opacity:1;stroke-dashoffset:16}to{stroke-dashoffset:0}}.visual_svg__cls-2{fill:#ebf0ff}.visual_svg__mask-line{stroke:var(--bs-white);stroke-width:11;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:16;stroke-dashoffset:0;animation-name:circle-ani;animation-duration:8.5s;animation-timing-function:cubic-bezier(.26,.9,.72,1)}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#visual_svg__mask-01)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.23 31a5.45 5.45 0 01-3.34 0C9.42 28.91 2.63 11 11.27 6.53h.05L8.2 7.67c-2.43.93-3.64 3.68-3.91 6.45a18.86 18.86 0 00.94 7.6A20.87 20.87 0 006 23.88c1.47 3.19 3.69 6.45 7.15 8l.57.22a6.48 6.48 0 001.56.28 5 5 0 001.93-.28L20.4 31a.47.47 0 00-.17 0z",
    fill: "url(#visual_svg__gradient_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.47 10c.22-2.67-3-5.78-5.07-7.36a15 15 0 00-4-2.16C11.9-.67 8.5.54 6 1.59a8.09 8.09 0 015.24.25c2.43.42 12.48 7.62 8.16 11.16 1.92-.75 3.83-1.44 4.07-3z",
    fill: "url(#visual_svg__gradient_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.69 42.35a5.14 5.14 0 01-3.32 0c-2.2-.67-4.31-3.3-5.77-4.62s-4.16.63-4.82.78a1.88 1.88 0 011.78.52 22.29 22.29 0 003.06 3.27 10 10 0 002.63 1.36 8.38 8.38 0 001.64.25c1.06.22 3.92-1.18 5-1.55a.34.34 0 00-.2-.01z",
    fill: "url(#visual_svg__gradient_4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.78 17.88c-.78.29-2.31.77-3.08 1.05l-.17.07c-2.5 1-3.66 3.79-3.92 6.44-.05 4.65-2.72 11.7-6 12.72 5.81-1.82 7.42-3.68 8.73-8.86.52-2.12.22-4.31.74-6.57.44-2 1.66-4.13 3.65-4.86.01 0 .01.02.05.01z",
    fill: "url(#visual_svg__gradient_5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.12 36.35a23.9 23.9 0 00-.19-3.05c0-.25 0-.35-.22-1.53A32.2 32.2 0 0045.16 20a24.49 24.49 0 00-4.11-5 18.09 18.09 0 00-5.26-3.41c-2.5-1-5.87.22-8.32 1.28a7.06 7.06 0 015 .12 10.75 10.75 0 012.64 1.27c9.27 5.8 17.46 28.46 5.94 35.25 7.02-1.91 9.03-6.03 9.07-13.16z",
    fill: "url(#visual_svg__gradient_6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.56 13.79a16.57 16.57 0 013.79 2.81 24.72 24.72 0 013.31 4 32.38 32.38 0 014.47 10.15 28.27 28.27 0 01.87 7.31 19.76 19.76 0 01-.7 4.94 12.52 12.52 0 01-1.72 3.72A7.32 7.32 0 0138.81 50a9.81 9.81 0 01-5-1.28 16.21 16.21 0 01-3.09-2.17 23.83 23.83 0 01-2.8-3 4.58 4.58 0 01-.81-4.41A1.31 1.31 0 0129 38.6a3.22 3.22 0 011 .86 15.06 15.06 0 001.86 2 10.88 10.88 0 002.06 1.44 7 7 0 002.55.83 4.87 4.87 0 002.27-.28A5.77 5.77 0 0042 39.94a12 12 0 00.76-4.17 17.39 17.39 0 00-.31-3.67 20.58 20.58 0 00-1-3.61 20 20 0 00-3.67-6.22 12.14 12.14 0 00-3.3-2.69 6.82 6.82 0 00-2.55-.82 4.7 4.7 0 00-2.26.28 5.78 5.78 0 00-3.22 3.48 11.93 11.93 0 00-.76 4.17 19.62 19.62 0 01-.69 4.88 12.29 12.29 0 01-1.72 3.72 7.3 7.3 0 01-5.77 3.33 9.79 9.79 0 01-5-1.28 17.1 17.1 0 01-3.79-2.81 24.79 24.79 0 01-3.31-4A32.22 32.22 0 01.86 20.4 28.76 28.76 0 010 13.07a20.11 20.11 0 01.69-4.89 12.54 12.54 0 011.72-3.72 7.37 7.37 0 015.77-3.33 9.8 9.8 0 015 1.29 17.07 17.07 0 013.28 2.32A23.6 23.6 0 0119.42 8c1 1.33 1.34 3.3.73 4.39a1.3 1.3 0 01-1.9.5 3.27 3.27 0 01-1-.93 16.53 16.53 0 00-1.95-2.15 11.26 11.26 0 00-2.19-1.55 7 7 0 00-2.55-.83 5 5 0 00-2.26.28 5.84 5.84 0 00-3.22 3.48 12 12 0 00-.76 4.18A17.24 17.24 0 004.6 19a21.34 21.34 0 001 3.62 20.07 20.07 0 003.67 6.22 12.44 12.44 0 003.3 2.68 7 7 0 002.55.83 4.87 4.87 0 002.27-.28 5.83 5.83 0 003.21-3.48 12 12 0 00.76-4.17 19.71 19.71 0 01.7-4.89 12.17 12.17 0 011.71-3.72 7.33 7.33 0 015.77-3.32 10 10 0 015.02 1.3z",
    fill: "#e3ebff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#visual_svg__mask-02)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.43 32.12a3.43 3.43 0 00-.06-.82 6.47 6.47 0 00-2.51-4.37 2.23 2.23 0 00-.49-.24c-1-.35-3.57.95-4.29 1.15a2.39 2.39 0 011.55.31 5.7 5.7 0 011.78 2 7.48 7.48 0 01.76 2.4c.19 1.15 0 3.11-1.2 3.59a37.14 37.14 0 003.78-1.67c.6-.32.73-1.19.68-2.35z",
    fill: "url(#visual_svg__gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "visual_svg__cls-2",
    d: "M33.62 28c1.56.83 2.79 3.29 2.74 5.47s-1.36 3.3-2.91 2.47-2.79-3.27-2.74-5.46 1.35-3.28 2.91-2.48z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#visual_svg__mask-03)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 19.72a3.51 3.51 0 00-.06-.83 6.47 6.47 0 00-2.51-4.37 2.23 2.23 0 00-.49-.24c-1-.35-3.57 1-4.28 1.15a2.51 2.51 0 011.54.31 5.89 5.89 0 011.78 2 7.29 7.29 0 01.75 2.4c.2 1.16 0 3.11-1.19 3.59a36.11 36.11 0 003.78-1.66c.68-.33.77-1.19.68-2.35z",
    fill: "url(#visual_svg__gradient_7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "visual_svg__cls-2",
    d: "M13.23 15.62c1.56.82 2.79 3.28 2.74 5.46s-1.35 3.29-2.91 2.46-2.79-3.28-2.74-5.47 1.35-3.28 2.91-2.45z"
  }))));
}

export default SvgVisual;